import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 w-screen overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_3 = { class: "mx-auto flex size-12 items-center justify-center rounded-full bg-yellow-100" }
const _hoisted_4 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = { class: "text-sm text-gray-500" }
const _hoisted_7 = { class: "mt-5 sm:mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_CloudIcon = _resolveComponent("CloudIcon")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    as: "template",
    show: _ctx.open
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        class: "relative z-50",
        onClose: _ctx.close
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TransitionChild, {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogPanel, { class: "relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_CloudIcon, {
                          class: "size-6 text-yellow-600",
                          "aria-hidden": "true"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_DialogTitle, {
                          as: "h3",
                          class: "text-base font-semibold text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.title), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.description), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_router_link, {
                          to: "/subscription",
                          class: "inline-flex w-full justify-center rounded-md bg-royal-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-royal-blue-500"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("button", {
                          type: "button",
                          class: "mt-2 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 cursor-pointer",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                        }, _toDisplayString(_ctx.$t('upload_limit_modal.close')), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose"])
    ]),
    _: 1
  }, 8, ["show"]))
}